export const MENU = {
  PORTFOLIO: 'PORTFOLIO',
  ABOUT: 'ABOUT',
  OUR_TEAM: 'OUR_TEAM',
  CONTACT_US: 'CONTACT_US'
}